import { useCallback, useMemo, useState } from "react";
import { OfferAssistantRecommendation } from "../../types";
import {
  recommendationMarks,
  recommendedOfferIds,
} from "./offerAssistantUtils";

/**
 * Glue between the offer assistant panel and an award screen. Holds the recommendation currently
 * marked in the matrix and turns the panel's events into pre-selections via `preselect`
 * (which dispatches the award reducer's APPLY_RECOMMENDATION). Nothing here ever awards.
 */
export const useAwardRecommendation = (
  preselect: (offerIds: string[]) => void
) => {
  const [recommendation, setRecommendation] =
    useState<OfferAssistantRecommendation | null>(null);

  const onRecommendation = useCallback(
    (next: OfferAssistantRecommendation) => {
      setRecommendation(next);
      preselect(recommendedOfferIds(next));
    },
    [preselect]
  );

  const marks = useMemo(
    () => recommendationMarks(recommendation),
    [recommendation]
  );

  return {
    marks,
    panelProps: {
      activeRecommendation: recommendation,
      onRecommendation,
      onShowRecommendation: setRecommendation,
      onApply: preselect,
      onDismiss: () => setRecommendation(null),
    },
  };
};
